module.exports = ".rff-preview-form {\n  height: auto;\n  padding: 10px 13px 10px 5px;\n  background: #FFF;\n  border: 1px solid #919191;\n  width: 565px; }\n\n.height-80 {\n  height: 80%;\n  position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rFF/form/form.component.scss
// module id = ./src/app/rFF/form/form.component.scss
// module chunks = main